export const policyHeaders = [
  {
    title: "Manage Policies",
    subtitle: "Define access levels and permissions for your team.",
    operation: "",
  },
  {
    title: "New Policy",
    subtitle: "Configure granular permissions for this role.",
    operation: "back",
  },
  {
    title: "Edit Policy",
    subtitle: "Configure granular permissions for this role.",
    operation: "back",
  },
];

export const PERMISSION_GROUPS_QUERY_KEY = ["permission-groups"] as const;
export const BRAND_PERMISSIONS_QUERY_KEY = ["brand-permissions"] as const;
